<uib-accordion close-others="oneAtATime">
  <div uib-accordion-group ng-repeat="exam in vm.examinations | filter: {active: true}"
       is-open="status.isOpen[$index]">
    <!-- exam header -->
    <uib-accordion-heading>
      <div class="row">
        <div class="col-xs-12 col-sm-9">
          <span style="position:absolute; top:20%; margin-right: 1em">
            <span ng-show="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index]"><i
                class="fa fa-caret-up fa-2x text-primary"></i></span>
            <span ng-hide="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index]"><i
                class="fa fa-caret-down fa-2x text-success"></i></span>&nbsp;
          </span>
          <span style="display: inline; position:relative; left: 2em">
            <h4>{{exam.template.displayname}}</h4>
            <p>{{exam.diagnosis}}</p>
          </span>
        </div>
        <div class="col-xs-12 col-sm-3" style="text-align: right">
          <h4>
            <a class="btn btn-primary btn-sm" href="/routes/pdfreader/{{exam.docid}}" target="_blank"
               ng-click="$event.stopPropagation();"
               uib-tooltip="PDF Ansicht">
              <i class="fa fa-eye"></i>
            </a>
            <a class="btn btn-primary btn-sm" href="/routes/pdfdownload/{{exam.docid}}"
               ng-click="$event.stopPropagation();"
               uib-tooltip="PDF speichern">
              <i class="fa fa-download"></i>
            </a>
          </h4>
        </div>
      </div>
    </uib-accordion-heading>
    <!-- exam data -->
    <div class="row">
      <examview exam="exam"></examview>
    </div>
  </div>  <!-- exam in openConsult.examinations -->
</uib-accordion>